import { DirectoryCreateRecordParam } from 'api/requests';
import { DirectorySchemaData } from 'api/types/data/directory/directory';
import { DirectoryRecordFieldParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseDirectoryRecordFieldParam = (
  currentSchema: DirectorySchemaData,
  values: {}
): DirectoryRecordFieldParam[] =>
  Object.values(currentSchema?.fieldDefinitions).map((field) => {
    let referenceRecordId;
    let value: any = values[field.name as keyof typeof values];

    if (value === undefined || value === null || value === '') {
      value = null;
    } else if (field.reference) {
      referenceRecordId = (value as { value: string }).value;
      value = undefined;
    } else if (typeof field.selectOptions?.[0]?.value === 'boolean') {
      value = {
        Boolean: (value as { value: boolean }).value,
      };
    } else if (field.component === 'Country') {
      value = { String: (value as { value: string }).value };
    } else if (field.component === 'Select') {
      value = { String: (value as { value: string }).value };
    } else if (field.component === 'Datetime') {
      value = { String: formatToISODate(new Date(value as string)) };
    } else if (field.isMultiLanguage) {
      const typeValue = value as { en: string; ru: string };
      value = {
        MultiLanguageTextDto_Input: {
          en: typeValue.en,
          ru: typeValue.ru,
        },
      };
    } else if (field.validation?.number) {
      value = {
        Float: Number(value),
      };
    } else {
      value = { String: String(value) };
    }

    return {
      name: field.name,
      referenceRecordId,
      value: value as DirectoryCreateRecordParam['fields'][number]['value'],
    };
  });
